import { render } from "./RegulatoryAlerts.vue?vue&type=template&id=1b6cb376&scoped=true"
import script from "./RegulatoryAlerts.vue?vue&type=script&lang=js"
export * from "./RegulatoryAlerts.vue?vue&type=script&lang=js"

import "./RegulatoryAlerts.vue?vue&type=style&index=0&id=1b6cb376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6cb376"]])

export default __exports__